/**
 * Get the value of a specific cookie by name.
 *
 * @param {string} name - The name of the cookie to retrieve.
 * @returns {string|null} - The value of the cookie if found, otherwise null.
 */
const getCookieValue = ( name ) => {
	const match = document.cookie.match( new RegExp( `(^| )${name}=([^;]+)` ) );
	if ( match ) return match[2];
	return null;
};

const jsonToUrlEncoded = ( json ) => Object.keys( json )
	.map( key => `${encodeURIComponent( key )}=${encodeURIComponent( json[key] )}` )
	.join( '&' );

/**
 * Perform an action before a Gravity Form is submitted.
 *
 * @param {number} formId The ID of the Gravity Form.
 */
const handleFormPreSubmission = () => {
    // Get calculator data first
    const calcValuesElement = document.querySelector('#calculator-results');
    let calculatorData = null;
    
    if (calcValuesElement) {
        try {
            calculatorData = JSON.parse(calcValuesElement.innerText);
        } catch (err) {
            console.error('Failed to parse calculator data:', err);
        }
    }

    // Check both main document and iframe contexts for form
    const form = document.querySelector('.gform_wrapper form') || 
                document.querySelector('#gform-frame')?.contentDocument?.querySelector('.gform_wrapper form');
    if (!form) return;
    
    // Find input in either context
    const inputField = form.querySelector('[name="input_9999"]') ||
                      document.querySelector('#gform-frame')?.contentDocument?.querySelector('[name="input_9999"]');
    if (!inputField) return;
    
    // Combine calculator data with cuvid
    const cuvid = getCookieValue('cuvid');
    const dataToSend = {
        ...(calculatorData || {}),
        cuvid: cuvid || ''
    };
    
    // Set the value
    inputField.value = jsonToUrlEncoded(dataToSend);
};

const handleSendCalcValues = () => {
    // Handle both iframe and direct form contexts
    const form = document.querySelector('dialog form') || 
                document.querySelector('#gform-frame')?.contentDocument?.querySelector('dialog form');
    if (!form) return;

    const { formid } = form.dataset;
    const calcValuesElement = document.querySelector('.calculator-result-packaged');
    const cuvid = getCookieValue('cuvid');
    
    // Check both contexts for input field
    const input = form.querySelector(`#field_${formid}_9999 input`) ||
                 document.querySelector('#gform-frame')?.contentDocument?.querySelector(`#field_${formid}_9999 input`);
    if (!input) return;

    let values = {};

    if (calcValuesElement) {
        const calculatorValues = JSON.parse(calcValuesElement.innerText);
        values = { ...calculatorValues };
    }

    if (cuvid) {
        values = { ...values, cuvid };
    }

    input.value = jsonToUrlEncoded(values);
};

document.addEventListener( 'DOMContentLoaded', () => {
	const targetNode = document.body;
	const observerOptions = {
		childList: true,
		subtree: true,
	};

	const attachEventListener = () => {
		const dialogTrigger = document.querySelector( '.dialog-trigger' );
		if ( dialogTrigger ) {
			// Remove existing listener first to prevent duplicates
			dialogTrigger.removeEventListener('click', handleSendCalcValues);
			dialogTrigger.addEventListener('click', handleSendCalcValues);
		}
	};

	const observer = new MutationObserver( ( mutationsList, observer ) => {
		attachEventListener();
	} );

	observer.observe( targetNode, observerOptions );

	// Attach event listener initially
	attachEventListener();
    
    // Initial setup
    handleFormPreSubmission();
    
    // Listen for calculator updates
    $(document).on('calculatorUpdated', function(e, data) {
        handleFormPreSubmission();
    });
    
    // Listen for form in iframe
    $(document).on('gform_post_render', function(event, formId) {
        if (formId === 64 || formId === 63) {
            handleFormPreSubmission();
        }
    });
} );

window.addEventListener( 'load', handleFormPreSubmission );
